import { Directive, TemplateRef, input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { IHasTableConfig } from '../pagination-table-config';

export declare class PaginationTableColumnSearchDirectiveContext<
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	T,
	F extends {
		[K in keyof F]: AbstractControl<any>;
	} = any,
> {
	$implicit: FormGroup<F>;
}

@Directive({
	selector: '[aePgtSearch]',
})
export class PaginationTableColumnSearchDirective<
	T,
	F extends {
		[K in keyof F]: AbstractControl<any>;
	},
> {
	readonly aePgtSearch = input<IHasTableConfig<T, F>>();
	readonly cellClass = input<string>();

	constructor(
		public template: TemplateRef<
			PaginationTableColumnSearchDirectiveContext<T, F>
		>,
	) {}

	static ngTemplateGuard_aePgtSearch: 'binding';
	static ngTemplateContextGuard<
		T,
		F extends {
			[K in keyof F]: AbstractControl<any>;
		},
	>(
		_dir: PaginationTableColumnSearchDirective<T, F>,
		_ctx: any,
	): _ctx is PaginationTableColumnSearchDirectiveContext<T, F> {
		return true;
	}
}
